import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, ExternalLink, Home, Calendar, Hash, PartyPopper } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
export function AdditionalPaymentThankYouPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderCopied, setOrderCopied] = useState(false);
  const name = searchParams.get('name') || 'חבר';
  const email = searchParams.get('email') || '';
  const orderNumber = searchParams.get('orderNumber') || '';
  const handleCopyOrderNumber = () => {
    navigator.clipboard.writeText(orderNumber);
    setOrderCopied(true);
    setTimeout(() => setOrderCopied(false), 2000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'התשלום התקבל! - Water Tribe Fest 2026';
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-cyan-50 to-white" dir="rtl" data-id="element-779">
      <Navigation data-id="element-780" />

      <div className="container mx-auto px-4 py-20" data-id="element-781">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-782">
          {/* Success Icon */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="flex justify-center mb-8" data-id="element-783">
            <div className="bg-cyan-100 rounded-full p-6" data-id="element-784">
              <CheckCircle className="w-20 h-20 text-cyan-600" data-id="element-785" />
            </div>
          </motion.div>

          {/* Thank You Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-center mb-12" data-id="element-786">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-787">
              מעולה {name}! 🌊
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-788">
              התשלום התקבל בהצלחה — מקומך בפסטיבל מובטח!
            </p>
          </motion.div>

          {/* Upgraded Dates Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.45
        }} className="bg-gradient-to-br from-[#0A5F8F] to-cyan-600 rounded-2xl p-6 md:p-8 shadow-lg mb-8 text-white text-center" data-id="element-789">
            <Calendar className="w-10 h-10 mx-auto mb-4 text-cyan-200" data-id="element-790" />
            <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-791">
              נתראה בתאריכים החדשים!
            </h2>
            <p className="text-3xl md:text-4xl font-black text-cyan-200 mb-3" data-id="element-792">
              9-11 באפריל 2026
            </p>
            <p className="text-cyan-100 text-lg" data-id="element-793">
              חוף מעגן עדן, כנרת — שיא העונה 🌞
            </p>
          </motion.div>

          {/* Order Number Card */}
          {orderNumber && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-cyan-200 mb-8" data-id="element-794">
              <div className="flex items-center gap-3 mb-4" data-id="element-795">
                <div className="bg-cyan-100 rounded-full p-2" data-id="element-796">
                  <Hash className="w-6 h-6 text-cyan-600" data-id="element-797" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-798">
                  מספר הזמנה
                </h2>
              </div>

              <p className="text-gray-600 mb-4" data-id="element-799">
                מספר ההזמנה של תוספת התשלום. שמור אותו לצורך התכתבות.
              </p>

              <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-6 border-2 border-cyan-100" data-id="element-800">
                <div className="flex items-center justify-between gap-4" data-id="element-801">
                  <div className="flex-1" data-id="element-802">
                    <p className="text-sm text-gray-600 mb-2" data-id="element-803">
                      מספר ההזמנה שלך:
                    </p>
                    <p className="text-3xl md:text-4xl font-black text-cyan-600 tracking-wider" data-id="element-804">
                      {orderNumber}
                    </p>
                  </div>
                  <button onClick={handleCopyOrderNumber} className="bg-cyan-100 hover:bg-cyan-200 p-4 rounded-xl transition-colors shrink-0" data-id="element-805">
                    {orderCopied ? <CheckCircle className="w-6 h-6 text-cyan-600" data-id="element-806" /> : <Copy className="w-6 h-6 text-cyan-600" data-id="element-807" />}
                  </button>
                </div>
              </div>
            </motion.div>}

          {/* Billing Announcement */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55
        }} className="bg-amber-50 rounded-2xl p-6 md:p-8 shadow-lg border-2 border-amber-300 mb-8" data-id="element-808">
            <div className="flex items-start gap-4" data-id="element-809">
              <div className="bg-amber-200 rounded-full p-3 shrink-0 mt-0.5" data-id="element-810">
                <span className="text-2xl" data-id="element-811">⚠️</span>
              </div>
              <div data-id="element-812">
                <h3 className="text-xl md:text-2xl font-black text-amber-900 mb-2" data-id="element-813">
                  שימו לב! ❤️
                </h3>
                <p className="text-lg font-semibold text-amber-800 leading-relaxed" data-id="element-814">
                  החיוב יופיע מחברת{' '}
                  <span className="font-black text-amber-950" data-id="element-815">
                    "אנרצ'י רפואה משלימה"
                  </span>
                  , סכום החיוב יהיה ₪240.
                </p>
              </div>
            </div>
          </motion.div>

          {/* WhatsApp Group */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-8" data-id="element-816">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-817">לא לשכוח!</h3>
            <div className="flex items-start gap-4" data-id="element-818">
              <div className="bg-green-100 rounded-full p-2 shrink-0" data-id="element-819">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-820" />
              </div>
              <div data-id="element-821">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-822">
                  קבוצת הווטסאפ של הפסטיבל
                </h4>
                <p className="text-gray-600 mb-2" data-id="element-823">
                  הישארו מעודכנים עם כל הפרטים החשובים לקראת הפסטיבל
                </p>
                <a href="https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA" target="_blank" rel="noopener noreferrer" className="text-[#0A5F8F] hover:underline font-semibold inline-flex items-center gap-2" data-id="element-824">
                  לחצו כאן להצטרפות לקבוצה
                  <ExternalLink className="w-4 h-4" data-id="element-825" />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Back to Festival Button */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-center" data-id="element-826">
            <Button onClick={() => navigate('/water-tribe-fest')} variant="outline" className="inline-flex items-center gap-2" data-id="element-827">
              <Home className="w-5 h-5" data-id="element-828" />
              חזרה לדף הפסטיבל
            </Button>
          </motion.div>
        </motion.div>
      </div>

      <Footer data-id="element-829" />
    </div>;
}